import { Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsecasepageService } from '../usecasepage.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-usecases-feature',
  templateUrl: './usecases-feature.component.html',
  styleUrls: ['./usecases-feature.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
  encapsulation: ViewEncapsulation.None,
})
export class UsecasesCaseFeatureComponent implements OnInit, OnChanges, OnDestroy {
  @Input() whitePaperData: any;
  @Input() pageData: any;
  constructor(private usecasepageService: UsecasepageService) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  caseFeatureData: any;

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    if (!this.pageData || !this.pageData.fields) {
      return;
    }
    const data = this.pageData.fields;
    if (data != null && data.caseStudyTemplate == 'Template 1') {
      this.caseFeatureData = data?.valuesContentPanel?.fields;
    }
  }
}
